import { InvalidateQueries } from '@mews/framework';
import { RepositoryRegistry, useRepositoryMutation } from '@mews-commander/data-access';
import { useCurrentServiceIdContext } from '../contexts';
import {
    SettlementConfigurationFormValues,
    settlementConfigurationSchema,
    toSettlementConfigurationEditParameters,
} from '../schemas';

export const useSettlementConfigurationUpdate = (
    rateGroupId: string,
    { invalidateQueries }: { invalidateQueries?: InvalidateQueries<RepositoryRegistry> } = {}
) => {
    const serviceId = useCurrentServiceIdContext();

    return useRepositoryMutation('rateGroups', 'update', {
        transformParams: (formValues: SettlementConfigurationFormValues) =>
            settlementConfigurationSchema
                .transform(toSettlementConfigurationEditParameters({ rateGroupId, serviceId }))
                .parse(formValues),
        invalidateQueries: invalidateQueries || {
            rateGroups: ['getAll', 'getOverviewEntries'],
        },
    });
};
